import UserService from '@boServices/userService';
import { useEffect, useState } from 'react';

const userService = new UserService();

// Backoffice users holding the CSM role (strict, no hierarchy), feeding the CSM pickers of the client forms.
// Without them a picker is simply empty, so a failed call is not surfaced.
const useCsmUsers = () => {
    const [csmUsers, setCsmUsers] = useState([]);

    useEffect(() => {
        userService
            .getUsers({ role: 'ROLE_CSM' })
            .then((response) => setCsmUsers(response?.items ?? []))
            .catch(() => setCsmUsers([]));
    }, []);

    return csmUsers;
};

export default useCsmUsers;
